import styled from 'styled-components';
import {cover} from 'polished';

export const LoadingCoverS = styled.div`
	${cover()};
	z-index: 2;
	color: ${({theme}) => theme.textColor};;
	background-color: ${({theme}) => theme.color1};;
`;
